function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.1667 15.4167C19.1667 16.7475 18.0809 17.8333 16.75 17.8333H3.41667C2.08579 17.8333 1 16.7475 1 15.4167L1.00037 5.39042C1.0005 5.38675 1.00065 5.38308 1.00083 5.37941C1.02036 4.06554 2.09825 3 3.41667 3H16.75C18.0809 3 19.1667 4.08579 19.1667 5.41667L19.1658 5.37941C19.166 5.38308 19.1662 5.38675 19.1663 5.39042L19.1667 15.4167ZM17.666 6.857L10.5134 11.8644C10.2875 12.0226 9.99607 12.0424 9.75375 11.9237L9.65324 11.8644L2.5 6.858V15.4167C2.5 15.8832 2.85715 16.2737 3.31047 16.3271L3.41667 16.3333H16.75C17.2525 16.3333 17.6667 15.9191 17.6667 15.4167L17.666 6.857ZM16.75 4.5H3.41667C3.03524 4.5 2.70467 4.7387 2.56755 5.07349L10.083 10.334L17.5991 5.07349C17.462 4.7387 17.1314 4.5 16.75 4.5Z",
  fill: "#333333"
});

function SvgMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.b72800fa.svg";
export { ForwardRef as ReactComponent };